import { render, staticRenderFns } from "./QaAnswerContent.vue?vue&type=template&id=6f3a3955"
import script from "./QaAnswerContent.vue?vue&type=script&lang=ts"
export * from "./QaAnswerContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports